var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation-drawer',{attrs:{"propDrawer":_vm.drawer},on:{"changeDrawer":_vm.changedDrawer}}),_c('app-bar',{attrs:{"propDrawer":_vm.drawer},on:{"changeDrawer":_vm.changedDrawer}}),_c('v-main',{class:!_vm.drawer ? 'not-expanded' : 'expanded',style:(`background-color: #f6fcfc; min-height: 100vh;`)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }